//
// Site Header
// --------------------------------------------------
// Functionality for mobile navigation toggling

const _debounce = require('lodash.debounce');
const _throttle = require('lodash.throttle');

import { PageUtils } from "./helpers/page-utils";

function unlockBody() {
    PageUtils.bodyLockToggleOff();
    const scrollCta = document.querySelector('button[data-scroll-cta]');
    if (scrollCta) {
        scrollCta.classList.remove('hidden');
    }
}

function lockBody() {
    PageUtils.bodyLockToggleOn();
    const scrollCta = document.querySelector('button[data-scroll-cta]');
    if (scrollCta) {
        scrollCta.classList.add('hidden');
    }
}

function initSiteHeader() {
    const docBody = document.body;
    const siteHeader = document.getElementById('siteHeader');
    const offCanvasMenuMobile = document.getElementById('offCanvasMenuMobile');
    const offCanvasMenuMobileAccordions = offCanvasMenuMobile?.querySelectorAll('[data-tw-toggle-container]')
    const offCanvasMenuDesktop = document.getElementById('offCanvasMenuDesktop');
    const menuToggleMobile = document.getElementById('menuToggleMobile');
    const navBackdropMobile = document.getElementById('navBackdropMobile');
    let scrollLimit = 500;
    let navOpenScrollPosY = window.scrollY;

    // id for below is retrieved from animated-hamburger.svg
    const hamburger = document.getElementById('ek0RzW3Va4r1');
    // https://www.svgator.com/help/getting-started/svgator-player-js-api
    // ^ related to below svgatorPlayer controls
    const player = hamburger ? hamburger.svgatorPlayer : {};

    function toggleHamburger() {
        if (hamburger) {
            if (player.play) {
                if (player.hasEnded || player.isPlaying) {
                    player.reverse();
                } else {
                    player.play();
                }
            }
        }
    }

    function closeHamburger() {
        if (hamburger) {
            if (player.play) {
                player.reverse();
            }
        }
    }

    if (offCanvasMenuMobile && menuToggleMobile) {
        menuToggleMobile.addEventListener('click', () => {
            // updates navOpenScrollPos on nav open so scroll limit can compare with the current open position
            navOpenScrollPosY = window.scrollY;

            if (window.matchMedia('(min-width: 1024px)').matches) {
                // desktop functions
                if (siteHeader) {
                    if (siteHeader.dataset.dropdown === 'false') {
                        siteHeader.dataset.dropdown = 'true';
                    } else {
                        siteHeader.dataset.dropdown = 'false';
                        closeDesktopNav()
                    }
                    toggleHamburger();
                    startListening();
                }
            } else {
                // mobile functions

                if (siteHeader) {
                    if (siteHeader.dataset.open === 'false') {
                        siteHeader.dataset.open = 'true';

                        if (navBackdropMobile) {
                            navBackdropMobile.dataset.open = 'true';
                        }
                        lockBody();
                    }
                    else {
                        siteHeader.dataset.open = 'false';
                        siteHeader.dataset.dropdown = 'false';

                        if (navBackdropMobile) {
                            navBackdropMobile.dataset.open = 'false';
                        }
                        unlockBody();

                        for (const offCanvasMenuMobileAccordion of offCanvasMenuMobileAccordions) {
                            offCanvasMenuMobileAccordion.dataset.open = 'false';
                        }
                    }
                }

                toggleHamburger();

                scrollLimit = (offCanvasMenuMobile.offsetHeight / 3) * 2;
                startListening();
            }
        });
    }

    if (offCanvasMenuDesktop) {
        initDesktopDrawerListeners();
    }

    function closeMobileNav() {
        if (siteHeader.dataset.open === 'true') {
            unlockBody();
            siteHeader.dataset.open = 'false';

            if (navBackdropMobile) {
                navBackdropMobile.dataset.open = 'false';
            }
            closeHamburger();

            for (const offCanvasMenuMobileAccordion of offCanvasMenuMobileAccordions) {
                offCanvasMenuMobileAccordion.dataset.open = 'false';
            }
        }
    }

    function closeDesktopNav() {
        if (siteHeader.dataset.dropdown === 'true') {
            siteHeader.dataset.dropdown = 'false';
            closeHamburger();
        }

        if (offCanvasMenuDesktop) {
            // Close new desktop drawers
            offCanvasMenuDesktop.dataset.drawerOpen = 'false';
            offCanvasMenuDesktop.querySelectorAll('[data-desktop-drawer]').forEach(drawer => {
                drawer.dataset.open = 'false';
            });

            // Set all toggle buttons to inactive
            siteHeader.querySelectorAll('[data-toggle-desktop-drawer]').forEach(btn => {
                btn.dataset.active = 'false';
            });

            // Close existing secondary/tertiary drawers
            offCanvasMenuDesktop.dataset.secondaryDrawerOpen = 'false';
            offCanvasMenuDesktop.dataset.tertiaryDrawerOpen = 'false';

            offCanvasMenuDesktop.querySelectorAll('[data-tertiary-drawer],[data-secondary-drawer]').forEach(drawer => {
                drawer.dataset.visible = 'false';
            });

            const openButtons = offCanvasMenuDesktop.querySelectorAll('[data-open-secondary-drawer],[data-open-tertiary-drawer]');
            for (const openButton of openButtons) {
                openButton.dataset.open = 'false';
            }
        }
    }

    // closes open menus and resets nav to default state
    function closeAllNavs() {
        closeMobileNav();
        closeDesktopNav();
    }

    function startListening() {
        window.addEventListener('click', clickListener);
        window.addEventListener('resize', resizeListener);
        window.addEventListener('scroll', scrollListener);
    }

    function stopListening() {
        window.removeEventListener('click', clickListener);
        window.removeEventListener('resize', resizeListener);
        window.removeEventListener('scroll', scrollListener);
    }

    // Throttle for resize listener to close open menus on page resize
    const closeNavResizeThrottle = _throttle(resizeCloseNav, 50, {leading: true, trailing: true});

    function resizeCloseNav() {
        let windowSize = window.innerWidth;
        setTimeout(() => {
            if (windowSize !== window.innerWidth) {
                closeAllNavs();
                stopListening();
            }
        }, 50);
    }


    // Debounce for click listener to close open menus if click is not inside menu
    const closeNavClickDebounce = _debounce(clickOutsideCloseNav, 50, {leading: true, trailing: true});

    function clickOutsideCloseNav() {
        if (!document.getElementById('siteHeader').contains(event.target)) {
            closeAllNavs();
            stopListening();
        }
    }


    // Throttle for scroll listener to close open menus if scroll exceeded scroll limit
    const closeNavScrollThrottle = _throttle(scrolledPastLimit, 50, {leading: true, trailing: true});

    function scrolledPastLimit() {
        if (siteHeader.dataset.open === 'false') {
            if (window.scrollY >= (scrollLimit + navOpenScrollPosY) || window.scrollY <= (navOpenScrollPosY - scrollLimit)) {
                closeAllNavs();
                stopListening();
            }
        }
    }

    const clickListener = () => {
        closeNavClickDebounce(event);
    };

    const resizeListener = () => {
        closeNavResizeThrottle();
    };

    const scrollListener = () => {
        closeNavScrollThrottle();
    };

    // Throttle for scroll listener to adjust nav position based on scroll
    const throttleNavScrollCheck =  _throttle(navScrollCheck, 50, {leading: true, trailing: false});
    window.addEventListener('scroll', throttleNavScrollCheck, {passive: true});

    let scrollPositive = window.scrollY + scrollLimit;
    setTimeout(() => {
        scrollPositive = window.scrollY + scrollLimit;
    }, 100);

    function navScrollCheck() {
        const scrollPos = window.scrollY;

        setTimeout(() => {
            // A page driving the scroll (editorial sub-nav jump) can hold the header hidden until the visitor takes over
            if (docBody?.dataset.navHold === 'hidden' && window.scrollY <= scrollLimit) delete docBody.dataset.navHold;
            if (docBody?.dataset.navHold === 'hidden') {
                setNavStyles(false);
                scrollPositive = window.scrollY + scrollLimit;
                return;
            }
            if (scrollPos > window.scrollY) {
                setNavStyles(true);
                scrollPositive = scrollPos + scrollLimit;
            } else if (scrollPos < window.scrollY) {
                if (scrollPositive < scrollPos) {
                    scrollPositive = scrollPos + scrollLimit;
                    setNavStyles(false);
                }
            }
        }, 50);
    }

    // A hold never survives a back/forward cache restore
    window.addEventListener('pageshow', (event) => {
        if (event.persisted && docBody) delete docBody.dataset.navHold;
    });

    // set nav position on load
    setNavStyles(true);

    // set nav pos / styles based on scrolling
    function setNavStyles(negScroll) {
        if (siteHeader && docBody) {
            if (document.body.dataset.lightboxOpen === 'true') return;
            const wasDropdownOpen = siteHeader.dataset.dropdown === 'true';

            if (window.scrollY > scrollLimit && !negScroll) {
                siteHeader.dataset.visible = 'false';
                docBody.dataset.navVisible = 'false';

                if (wasDropdownOpen) {
                    closeDesktopNav();
                }
            }
            else if (window.scrollY > scrollLimit && negScroll) {
                siteHeader.dataset.visible = 'true';
                docBody.dataset.navVisible = 'true';
            }
            else {
                siteHeader.dataset.visible = 'true';
                docBody.dataset.navVisible = 'true';
            }
        }
    }

    // Keeps offcanvas nav hidden for 500ms on page load to mask transitions
    setTimeout(function() {
        document.getElementById('offCanvasMenuMobile')?.removeAttribute('style');
    }, 500);


    function initDesktopDrawerListeners() {
        // Add a single click listener to the site header for better performance and reliability
        if (siteHeader) {
            siteHeader.addEventListener('click', (event) => {
            const target = event.target;

            // Handle desktop drawer toggle buttons
            if (target.matches('[data-toggle-desktop-drawer]') || target.closest('[data-toggle-desktop-drawer]')) {
                const toggleButton = target.matches('[data-toggle-desktop-drawer]') ? target : target.closest('[data-toggle-desktop-drawer]');
                const drawerIndex = toggleButton.dataset.toggleDesktopDrawer;
                const targetDrawer = offCanvasMenuDesktop.querySelector(`[data-desktop-drawer="${drawerIndex}"]`);

                if (targetDrawer) {
                    const isCurrentlyOpen = targetDrawer.dataset.open === 'true';

                    // Close all desktop drawers first and set all toggle buttons to inactive
                    offCanvasMenuDesktop.querySelectorAll('[data-desktop-drawer]').forEach(drawer => {
                        drawer.dataset.open = 'false';
                    });

                    // Set all toggle buttons to inactive
                    siteHeader.querySelectorAll('[data-toggle-desktop-drawer]').forEach(btn => {
                        btn.dataset.active = 'false';
                    });

                    // If the clicked drawer wasn't open, open it
                    if (!isCurrentlyOpen) {
                        targetDrawer.dataset.open = 'true';
                        offCanvasMenuDesktop.dataset.drawerOpen = 'true';

                        // Set the clicked toggle button to active
                        toggleButton.dataset.active = 'true';

                        // Set the site header dropdown state to true to show the desktop nav
                        if (siteHeader) {
                            siteHeader.dataset.dropdown = 'true';
                        }

                        startListening();
                    } else {
                        // If it was open and we're closing it, close the entire desktop nav
                        offCanvasMenuDesktop.dataset.drawerOpen = 'false';
                        closeDesktopNav();
                    }
                }
                return;
            }

            // Handle close desktop nav buttons
            if (target.matches('[data-close-desktop-nav]') || target.parentElement?.matches('[data-close-desktop-nav]')) {
                closeDesktopNav();
                return;
            }
        });
        }
    }
}

window.addEventListener('load', () => {
    // Only reinitialize if elements weren't found the first time
    const offCanvasMenuDesktop = document.getElementById('offCanvasMenuDesktop');
    if (offCanvasMenuDesktop) {
        initSiteHeader();
    }
});